import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./NavBar";
import "./App.css";
import { refreshAccessToken } from "./auth";

function KullaniciPanel() {
  const [formData, setFormData] = useState({ kullanicikodu: "", parola: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  //const server_URL = `http://192.168.2.250:50`;
  const [eski,setEski] = useState('');
  const [yeni,setYeni]= useState('');
  const [message,setMessage] = useState('');
  const [color, setColor] = useState('red');
  const [user, setuser]=useState(null);
  useEffect(() => {
      async function init() {
        const success = await refreshAccessToken();
        if (!success) {
          console.log('Refresh failed, redirected to login.');
          return;
        }
    
        try {
          const res = await fetch('/me', { credentials: 'include' });
          const data = await res.json();
          if (res.ok) {
            if (data.sicil_no) {
              //setFormData((prevData) => ({ ...prevData, SICIL_NO: data.SICIL_NO }));
              setuser(data);
              //fetchIzinler(data);
            } else {
              console.error("Sicil bilgisi bulunamadı");
            }
          } else {
            console.error("User fetch error:", data.error);
          }
        } catch (err) {
          console.error("User fetch exception:", err);
        }
      }
    
      init();
    }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`/sifre_guncelle`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials:'include',
        body: JSON.stringify({eski,yeni}),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || "İşlem başarısız");
      }else {
        setColor('green');
        setMessage("Şifre güncellendi.");
        setEski('');
        setYeni('');
      }
      console.log(data);
      console.log(response);

 

    } catch (err) {
      console.error('Login error:',err.message);
      if(err.message==='no_token'||err.message==='token_expired'||err.message==='invalid_token')
         navigate(`/login`);
      else setError(err.message);
    }
  };

  return (
    <div>
    <Navbar />
    <div className="container">
      <img src="/logo.png" alt="Logo" className="logo" />
      <h1>Şifre Güncelleme</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <label>Eski Şifre</label>
        <input
          type="password"
          value={eski}
          onChange={(e) =>
            setEski(e.target.value)
          }
        />
        <label>Yeni Şifre</label>
        <input
          type="password"
          value={yeni}
          onChange={(e) => setYeni(e.target.value )}
        />
        <button type="submit">Güncelle</button>
      </form>
      {message&&<p style={{color}}>{message}</p>}
    </div>
    </div>
  );
}

export default KullaniciPanel;
